import { useEffect } from 'react';

const CopyPasteHandler = ({ examDetail }) => {
  useEffect(() => {
    const handleCopyPaste = (e) => {
      e.preventDefault();
      if (examDetail && examDetail[0]) {
        examDetail[0].copyPasteAttempts = (examDetail[0].copyPasteAttempts || 0) + 1;
      }
    };

    document.addEventListener('copy', handleCopyPaste);
    document.addEventListener('cut', handleCopyPaste);
    document.addEventListener('paste', handleCopyPaste);

    return () => {
      document.removeEventListener('copy', handleCopyPaste);
      document.removeEventListener('cut', handleCopyPaste);
      document.removeEventListener('paste', handleCopyPaste);
    };
  }, [examDetail]);

  return null;
};

export default CopyPasteHandler;
